// ── Adapter Supabase do IRealtimeGateway ──────────────────────────
// Única camada que conhece supabase.channel / postgres_changes.

import { getSupabase } from '@infra/supabase/client';
import type { IRealtimeGateway, SubscribeTableParams } from '@modules/realtime';

export class SupabaseRealtimeGateway implements IRealtimeGateway {
  subscribeToTable = ({ table, filter, onChange }: SubscribeTableParams): (() => void) => {
    const supabase = getSupabase();
    if (!supabase) return () => {};
    const channel = supabase
      .channel(`rt-${table}-${Math.random().toString(36).slice(2, 10)}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table, ...(filter ? { filter } : {}) },
        (payload) => onChange({
          eventType: payload.eventType as 'INSERT' | 'UPDATE' | 'DELETE',
          new: (payload.new ?? null) as Record<string, unknown> | null,
          old: (payload.old ?? null) as Record<string, unknown> | null,
        }),
      )
      .subscribe();
    return () => { supabase.removeChannel(channel); };
  };

  getConnectionState = (): string => {
    const supabase = getSupabase();
    const rt = supabase?.realtime as unknown as {
      connection?: { connectionState?: string; readyState?: number };
      isConnected?: () => boolean;
    } | undefined;
    if (!rt) return 'CLOSED';
    try {
      const state = rt.connection?.connectionState
                 || (rt.isConnected?.() ? 'OPEN' : 'CLOSED');
      return typeof state === 'string' ? state.toUpperCase() : 'OPEN';
    } catch {
      return 'CLOSED';
    }
  };
}
